import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import type { NewCarsVehicle } from '~/contracts/new-cars';
import useMatchingVehiclesData from './useMatchingVehiclesData';

export default function useClosestVehicle(): NewCarsVehicle | null {
  const { selectedOptions } = useContext(ParentModelContext);
  const { matchingVehicles } = useMatchingVehiclesData();

  if (matchingVehicles.length !== 1) return null;

  const [vehicle] = matchingVehicles;

  const driveTypeMatches =
    vehicle.driveType?.name === selectedOptions?.driveType;
  const engineMatches = vehicle.engine?.code === selectedOptions?.engineCode;
  const exteriorColorMatches =
    vehicle.exteriorColor?.code === selectedOptions?.exteriorColorCode;
  const interiorColorMatches =
    vehicle.interiorColor?.code === selectedOptions?.interiorColorCode;
  const packageOptionsMatch = vehicle.packageOptions.every(
    packageOption =>
      selectedOptions?.packageOptionCodes?.includes(packageOption.code)
  );

  return driveTypeMatches &&
    engineMatches &&
    exteriorColorMatches &&
    interiorColorMatches &&
    packageOptionsMatch
    ? vehicle
    : null;
}
